/**
 * Storage cleanup utilities
 * Removes stale data from localStorage to minimize security exposure
 */

/**
 * Removes abandoned download:* entries from localStorage.
 * Download entries are used for cross-window handoff and should be
 * short-lived. If a download window never loads or is closed early,
 * these entries accumulate indefinitely and can leak query metadata.
 *
 * On app startup (browser restart/refresh), any pending downloads are
 * already abandoned, so we remove all download:* entries.
 */
export function cleanupStaleDownloadEntries(): void {
    try {
        const keysToRemove: string[] = [];

        // Identify all download entries
        Object.keys(localStorage).forEach(key => {
            if (key.startsWith('download:')) {
                keysToRemove.push(key);
            }
        });

        // Remove all download entries
        keysToRemove.forEach(key => {
            localStorage.removeItem(key);
        });

        if (keysToRemove.length > 0) {
            console.log(`[Storage Cleanup] Removed ${keysToRemove.length} abandoned download entries`);
        }
    } catch (err) {
        console.error('[Storage Cleanup] Error during cleanup:', err);
    }
}

/**
 * Initialize storage cleanup on app startup.
 * Should be called early in the application lifecycle.
 */
export function initStorageCleanup(): void {
    cleanupStaleDownloadEntries();
}
